interface ApiError {
	request: XMLHttpRequest;
	response?: Response;
	config?: { url?: string };
	message: string;
	stack: string;
	code: string;
}

interface Response {
	status: number;
	statusText: string;
	data: any;
	config: any;
	headers: any;
	request: XMLHttpRequest;
}

export function catchError(e: ApiError, errorMessageEnabled: boolean = true) {
	if (errorMessageEnabled) {
		if (e.response?.data?.displayableError) {
			// @ts-ignore
			MeddiApp.notification(e.response.data.message);
			// @ts-ignore
		} else if (isNetworkError(e)) {
			// Display error message when user is not connected to the internet
			// @ts-ignore
			MeddiApp.notification(jsTranslation['base.shared.notConnected']);
			// @ts-ignore
		} else if (e.response?.status === 400) {
			if (isGraphqlRequest(e)) {
				console.error('GraphQL request failed', e.response?.data?.errors);
				notifyUnexpectedErrorOnce();
			} else if ((e.response?.data?.errors?.length || 0) > 0) {
				e.response?.data?.errors?.forEach((error: { message: string }) => {
					// @ts-ignore
					MeddiApp.notification(error.message);
				});
			}
		} else if (e.code !== 'ECONNABORTED') {
			// @ts-ignore
			MeddiApp.notification(jsTranslation['base.shared.warningBug']);
		}
	}

	return {
		data: { ...e.response?.data, error: true },
		status: e.response?.status,
		statusText: e.response?.statusText,
	};
}

function isGraphqlRequest(error: ApiError) {
	const url = error.config?.url || error.response?.config?.url || '';
	return url.replace(/\?.*$/, '').replace(/\/$/, '').endsWith('/graphql');
}

const UNEXPECTED_ERROR_THROTTLE = 5000;
let lastUnexpectedErrorAt = 0;

function notifyUnexpectedErrorOnce() {
	const now = Date.now();
	if (now - lastUnexpectedErrorAt < UNEXPECTED_ERROR_THROTTLE) {
		return;
	}
	lastUnexpectedErrorAt = now;
	// @ts-ignore
	MeddiApp.notification(jsTranslation['base.shared.warningBug']);
}

export function isNetworkError(error: ApiError) {
	// @ts-ignore
	const isOnline = window.navigator.onLine;
	// Check if the error message or code suggests a network issue
	const errorMessage = error.message.toLowerCase();
	return (
		!isOnline ||
		errorMessage.includes('network') ||
		errorMessage.includes('internet') ||
		errorMessage.includes('offline') ||
		error.code === 'ERR_INTERNET_DISCONNECTED' ||
		error.code === 'ENOTFOUND'
	);
}
